export function isAndroid() {
    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf('android') !== -1;
    return isAndroid;
}

export function isIOS() {
    let ua = navigator.userAgent.toLowerCase();
    let isIos = ua.indexOf('iphone') !== -1;
    return isIos;
}

export const ISWECHAT = (() => {
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
})();

export function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
        ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
        ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
        return true;
    } else {
        return false;
    }
}

export function getIOSVersion() {
    // 获取固件版本
    var getOsv = function () {
        var reg = /OS ((\d+_?){2,3})\s/;
        if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
            var osv = reg.exec(navigator.userAgent);
            if (osv.length > 0) {
                return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
            }
        }
        return '';
    };
    var osv = getOsv();
    var osvArr = osv.split('.');
    console.log(osvArr);
    // 初始化显示ios9引导
    if (osvArr && osvArr.length > 0) {
        return parseInt(osvArr[0]);
    }
    return false;
}